import { I_RealestateCard } from "@/src-refactor/modules/shared/model/interface/realestate-card.interface";
import {
  PropertyItemList,
  PropertyListResponse
} from "../../../store/qrtk/services/realestate/responses/property-list.response";
import {
  PROPERTIES_STATUS_FOR_ID,
  PropertyStatus
} from "@/src-refactor/modules/shared/model/const/property/real-estate-status";
import categorizeFeaturesHelper from "@/src-refactor/modules/shared/helpers/categorize-features.helpers";
import { O_CONDICTION_PROPERTY_FOR_NAME } from "@/src-refactor/modules/shared/model/const/property/condition-status.const";
import MoneyFormat from "@/src-refactor/modules/shared/helpers/moneyFormat.helper";
import { capitalize } from "lodash";
import {
  C_BUSINESS_TYPE_ID,
  O_BUSINESS_TYPE
} from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { HPreparePrice } from "@rf-helper/property/prepare-price-property";
import { O_COMMISSION_RENT_ALL } from "@/src-refactor/modules/shared/model/const/property/comission_rent.const";

export const ListPropertiesAdapter = (responses: PropertyListResponse) => {
  const { data, ...rest } = responses;
  const info: I_ListPropertiesAdapter = {
    ...rest,
    data: []
  };

  const getPrices = (item: PropertyItemList) => {
    return HPreparePrice({
      alternativePrice: `${item.alternate_price}`,
      businessTypeId: item.business_type
        ? O_BUSINESS_TYPE[item.business_type].id
        : 0,
      currencyAlternativePrice: item.alternative_currency.symbol,
      currencyPrice: item.currency.symbol,
      isProject: item.project?.id ? true : false,
      maximumPrice: item.project?.maximum_price || "",
      minimumPrice: item.project?.minimum_price || "",
      price: item.price || ""
    });
    // if (item.project) {
    //   const prices = {
    //     rent: null,
    //     sale: `
    //     ${
    //       item?.project?.separation_currency?.symbol ??
    //       item.currency.symbol
    //     } $${MoneyFormat(item?.project?.minimum_price)} -
    //     ${
    //       item?.project?.separation_currency?.symbol ??
    //       item.currency.symbol
    //     } $${MoneyFormat(item?.project?.maximum_price)} `
    //   };
    //   return [
    //     {
    //       label: "Venta",
    //       value: prices.sale
    //     }
    //   ];
    // } else {
    //   const business_type = O_BUSINESS_TYPE[item.business_type];
    //   if (!!!business_type) {
    //     return [
    //       {
    //         label: "Error",
    //         value: "Error"
    //       }
    //     ];
    //   }
    //   const prices = {
    //     alternate_price:
    //       +item?.alternate_price && +item?.alternate_price > 0
    //         ? `${item?.alternative_currency?.symbol} $${MoneyFormat(item?.alternate_price)}`
    //         : null,
    //     price:
    //       item?.price && +item?.price > 0
    //         ? `${item?.currency?.symbol} $${MoneyFormat(+item?.price)}`
    //         : null,
    //     label: "Error"
    //   };

    //   if (business_type.id == C_BUSINESS_TYPE_ID.RENT) {
    //     return [
    //       {
    //         label: business_type.name,
    //         value: prices.price
    //       }
    //     ];
    //   } else if (business_type.id == C_BUSINESS_TYPE_ID.SALE) {
    //     return [
    //       {
    //         label: business_type.name,
    //         value: prices.price
    //       }
    //     ];
    //   } else if (business_type.id == C_BUSINESS_TYPE_ID.SALE_AND_RENT) {
    //     return [
    //       {
    //         label: "Venta",
    //         value: prices.price
    //       },
    //       {
    //         label: "Alquiler",
    //         value: prices.alternate_price
    //       }
    //     ];
    //   } else if (business_type.id == C_BUSINESS_TYPE_ID.RENT_FURNISHED) {
    //     return [
    //       {
    //         label: "Alquiler Amueblado",
    //         value: prices.price
    //       }
    //     ];
    //   } else if (
    //     business_type.id == C_BUSINESS_TYPE_ID.SALE_AND_FURNISHED_RENTAL
    //   ) {
    //     return [
    //       {
    //         label: "Venta Amueblado",
    //         value: prices.price
    //       },
    //       {
    //         label: "Alquiler Amueblado",
    //         value: prices.alternate_price
    //       }
    //     ];
    //   } else if (
    //     business_type.id ==
    //     C_BUSINESS_TYPE_ID.SALE_AND_RENTAL_OF_WHITE_GOODS
    //   ) {
    //     return [
    //       {
    //         label: "Venta de Línea Blanca",
    //         value: prices.price
    //       },
    //       {
    //         label: "Alquiler de Línea Blanca",
    //         value: prices.alternate_price
    //       }
    //     ];
    //   } else if (business_type.id == C_BUSINESS_TYPE_ID.SALE_FURNISHED) {
    //     return [
    //       {
    //         label: "Venta Amueblado",
    //         value: prices.price
    //       }
    //     ];
    //   } else if (
    //     business_type.id == C_BUSINESS_TYPE_ID.WHITE_LINE_RENTAL
    //   ) {
    //     return [
    //       {
    //         label: "Alquiler de Línea Blanca",
    //         value: prices.price
    //       }
    //     ];
    //   } else if (business_type.id == C_BUSINESS_TYPE_ID.WHITE_LINE_SALES) {
    //     return [
    //       {
    //         label: "Venta de Línea Blanca",
    //         value: prices.price
    //       }
    //     ];
    //   } else {
    //     return [
    //       {
    //         label: "Error",
    //         value: prices.label
    //       }
    //     ];
    //   }
    // }
  };

  const getId = (item: PropertyItemList) => {
    if (item.project) {
      return item.id;
    } else {
      return item.id;
    }
  };
  info.data = data.map((item: PropertyItemList) => {
    return {
      title: `${item?.realstate_type} en ${item?.sector} ${item?.city}`,
      name: item?.name,
      agents: item?.agent_list?.map(x => x?.name)?.join(", "),
      id: getId(item),
      is_project: !!item?.project,
      project_id: item?.project?.id,
      likes_counter: item?.likes_counter,
      views_counter: item?.views_counter,
      shares_counter: item?.shares_counter,
      business_type_base: item.business_type ? O_BUSINESS_TYPE[item.business_type].combine.business : 0,
      status: PROPERTIES_STATUS_FOR_ID[item?.status_id] as unknown as PropertyStatus,
      features: categorizeFeaturesHelper(item?.improvements),
      improvements: {
        bathrooms: item?.bathrooms,
        bedrooms: item?.bedrooms,
        parking_lot: item?.parking_spots,
        sqm_construction: item?.sqm_construction,
        sqm_land: item?.sqm_land,
        floor_level: item?.floor_level,
        floors_total: item?.floors_total,
        pumps: item?.pumps
      },
      location: `${capitalize(item?.sector)}, ${capitalize(
        item?.city
      )}`.toLocaleUpperCase(),
      prices: getPrices(item),
      commission_percents: item.total_comission,
      lease_commission: item?.lease_commission
        ? `${item?.lease_commission} Mes${item?.lease_commission > 1 ? "es" : ""}` 
        : null ,
      pictures: item?.main_picture?.big,
      condition: O_CONDICTION_PROPERTY_FOR_NAME[item?.condition_status] ?? null,
      agents_info_full: item?.agent_list?.map(x => ({
        name: x?.name,
        id: x?.id,
        email: x?.email,
        agency_id: x?.agency_id
      })),
      dirtyData: item,
      type_property: item.realstate_type,
      address: item.address,
      improvementsList: item.improvementsList
    };
  });

  return { ...info };
};

interface I_ListPropertiesAdapter {
  data: I_RealestateCard[];
  links: PropertyListResponse["links"];
  meta: PropertyListResponse["meta"];
  message: PropertyListResponse["message"];
}
